export const CONST = {
  SEND_VERIFICATION_EMAIL: '@dashboard/SEND_VERIFICATION_EMAIL',
  SET_FIELD: '@dashboard/SET_FIELD',
  SEND_DOCUMENTATION_EMAIL: '@dashboard/SEND_DOCUMENTATION_EMAIL',
};

export default CONST;